import { createContext, useContext, useState } from 'react'

import { AppSettings } from '../appSettings'
import type { IPartnerSettings } from '../appSettings/Partners'
import { getPartnerByHost } from '../appSettings/Partners'

export const PartnerContext = createContext<{
  currentPartner: IPartnerSettings | undefined
  setCurrentPartner: React.Dispatch<
    React.SetStateAction<IPartnerSettings | undefined>
  >
  getOrigAppUrl: () => string
  getBaseUrl: () => string
  getAppUrl: () => string
}>({} as any)

export const PartnerContextProvider = (props: {
  children: React.ReactNode
}) => {
  const [currentPartner, setCurrentPartner] = useState(getPartnerByHost())

  return (
    <PartnerContext.Provider
      value={{
        currentPartner: currentPartner,
        setCurrentPartner: setCurrentPartner,
        // getBaseUrl: () => currentPartner?.baseUrl[AppSettings.enviroment] ?? '',
        getBaseUrl: () => AppSettings.baseUrl,
        getOrigAppUrl: () =>
          currentPartner?.origAppUrl[AppSettings.enviroment] ?? '',
        getAppUrl: () => window.location.origin + import.meta.env.VITE_BASE_URL,
      }}
    >
      {props.children}
    </PartnerContext.Provider>
  )
}

export const usePartner = () => {
  const context = useContext(PartnerContext)

  if (!context || context === undefined) {
    throw new Error('usePartner must be used within a PartnerContextProvider')
  }

  return context
}
